<!-- begin:: Content Head -->
<div
  class="kt-subheader kt-grid__item"
  [ngClass]="{ 'kt-container--clear': clear }"
  [hidden]="subheaderService.disabled$ | async"
  id="kt_subheader"
>
  <div class="kt-container" [ngClass]="{ 'kt-container--fluid': fluid }">
    <div class="kt-subheader__main">
      <div class="kt-subheader__breadcrumbs" *ngIf="(breadcrumbs$ | async).length > 0">
        <a class="kt-subheader__breadcrumbs-home" [routerLink]="['/']">
          <i class="flaticon-home-1"></i>
        </a>

        <ng-container *ngFor="let item of breadcrumbs$ | async">
          <i class="flaticon2-right-arrow separator"></i>

          <a [routerLink]="item.page" [queryParams]="item.queryParams" class="kt-subheader__breadcrumbs-link">
            {{ item.translate ? (item.translate | transloco) : item.title }}
          </a>
        </ng-container>
      </div>

      <kt-horizontal-menu *ngIf="!isAdmin"></kt-horizontal-menu>
    </div>
  </div>
</div>
<!-- end:: Content Head -->
